import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-k01-header" }
const _hoisted_2 = {
  class: "p-the-k01-header__title",
  "data-translate-skip": ""
}
const _hoisted_3 = { class: "p-the-k01-header__info" }
const _hoisted_4 = { class: "p-the-k01-header__info__item" }
const _hoisted_5 = { class: "p-the-k01-header__info__item" }
const _hoisted_6 = { class: "p-the-k01-header__info__item" }
const _hoisted_7 = { "data-translate-skip": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, " 掲載日時：" + _toDisplayString(_ctx.customDateFormat(_ctx.publishedAt)), 1),
      _createElementVNode("div", _hoisted_5, " 更新日時：" + _toDisplayString(_ctx.customDateFormat(_ctx.updatedAt)), 1),
      _createElementVNode("div", _hoisted_6, [
        _cache[0] || (_cache[0] = _createTextVNode(" 作成者：", -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.authorName), 1),
        _createTextVNode(" (ID: " + _toDisplayString(_ctx.authorId) + ") ", 1)
      ])
    ])
  ]))
}